
import { Bot, BrainCircuit, Network, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface ChatHeaderProps {
  orchestrationActive: boolean;
  complexity: 'simple' | 'medium' | 'complex';
}

export const ChatHeader = ({ orchestrationActive, complexity }: ChatHeaderProps) => {
  return (
    <div className="border-b bg-card flex items-center justify-between p-4">
      <div className="flex items-center gap-3">
        <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center">
          <Bot className="h-5 w-5 text-primary" />
        </div>
        <div>
          <h2 className="font-semibold text-base">BrigAI Assistant</h2>
          <p className="text-xs text-muted-foreground">
            AI orchestrator and executive assistant
          </p>
        </div>
      </div>
      
      <div className="flex items-center gap-2">
        {orchestrationActive && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div className={cn(
                  "px-2 py-1 rounded-full text-xs flex items-center gap-1.5 animate-pulse",
                  complexity === 'simple' ? "bg-blue-100 text-blue-700" : 
                  complexity === 'medium' ? "bg-amber-100 text-amber-700" : 
                  "bg-purple-100 text-purple-700"
                )}>
                  <BrainCircuit className="h-3 w-3" />
                  <span>
                    {complexity === 'simple' ? "Basic" : 
                    complexity === 'medium' ? "Standard" : 
                    "Advanced"} Orchestration
                  </span>
                  {complexity === 'complex' && <Network className="h-3 w-3" />}
                </div>
              </TooltipTrigger>
              <TooltipContent side="bottom">
                <p className="text-xs max-w-[220px]">
                  {complexity === 'simple' 
                    ? "Basic orchestration with minimal coordination between agents" 
                    : complexity === 'medium' 
                    ? "Standard orchestration with sequential agent processing" 
                    : "Advanced orchestration with parallel processing and agent-to-agent communication"}
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
    </div>
  );
};
